export default __webpack_public_path__ + "static/media/ChosainCrossroads.d27424f5.jpg";